import { render, staticRenderFns } from "./SalvaSessione.vue?vue&type=template&id=2f090ff1&"
import script from "./SalvaSessione.vue?vue&type=script&lang=js&"
export * from "./SalvaSessione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports